import { FormControl, FormHelperText, FormLabel, Radio, RadioGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { AdminControlCheckbox } from '../../../utils/AdminControlCheckbox';

const VersionSelectDiv = styled.div`
    margin-top: 24px;
`;

const StyledFormLabel = styled(FormLabel)``;

interface LTITypeSelectProps {
    ltiVersion: string;
    type: string;
    handleChange: (event) => void;
}

const LTITypeSelect: React.FC<LTITypeSelectProps> = ({ ltiVersion, type, handleChange }) => {
    const { t } = useTranslation('admin_settings');
    const disabled = type == 'Docebo';
    return (
        <VersionSelectDiv>
            <FormControl disabled={disabled}>
                <StyledFormLabel id="lti-select-buttons-group-label">{t('lti-type')}</StyledFormLabel>
                <RadioGroup
                    aria-labelledby="lti-select-buttons-group-label"
                    value={ltiVersion}
                    name="lti_version"
                    onChange={handleChange}
                >
                    <AdminControlCheckbox control={<Radio value="1.1" />} label={t('lti-11')} />
                    <AdminControlCheckbox control={<Radio value="1.3" />} label={t('lti-13')} />
                </RadioGroup>
                <FormHelperText>{t('lti-select-helper-text')}</FormHelperText>
            </FormControl>
        </VersionSelectDiv>
    );
};

export default LTITypeSelect;
